export default __webpack_public_path__ + "static/media/Headshots.d4e5a124.png";